import { gql } from "@apollo/client";

import { TRANSACTION_INFO } from "../fragments";

export const GET_TRANSACTION_RECORD = gql`
  query myTransaction($action: String) {
    myTransaction(action: $action) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;
